import React from 'react';
import { DocumentPeriod } from '../../../utils/documentUtils';
import { DocumentType } from '../../../types/Document';
import styles from '../../../styles/DocumentManagement.module.css';

interface DocumentPeriodSelectorProps {
  type: DocumentType;
  periods: DocumentPeriod[];
  selectedPeriodKey: string;
  onSelectionChange: (key: string) => void;
}

const DocumentPeriodSelector: React.FC<DocumentPeriodSelectorProps> = ({
  type,
  periods,
  selectedPeriodKey,
  onSelectionChange,
}) => {
  // Only show selector for recurring types with more than one period slot
  if (type.recurrence === 'none' || periods.length <= 1) {
    return null;
  }

  return (
    <div className={styles.documentPeriodSelector}>
      <label htmlFor={`period-select-${type.id}`}>Period:</label>
      <select
        id={`period-select-${type.id}`}
        value={selectedPeriodKey}
        onChange={e => onSelectionChange(e.target.value)}
      >
        {periods.map(period => (
          <option key={period.key} value={period.key}>
            {period.label}{period.isCurrent ? ' (Current)' : ''}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DocumentPeriodSelector;

